import {Box} from 'grommet'
import {QueryClient, QueryClientProvider} from 'react-query'
import {BrowserRouter as Router} from 'react-router-dom'

import {ShinyConfig} from '@mindthecoin/shiny'

import Header from './components/layout/Header'
import {TranslationProvider} from './components/translation/TranslationContext'
import Footer from './components/layout/Footer'
import Routes from './Routes'
import { AuthProvider } from './components/auth/AuthContext'

const queryClient = new QueryClient()

function App() {
  return (
    <ShinyConfig>
      <QueryClientProvider client={queryClient}>
        <Router>
          <TranslationProvider>
            <AuthProvider>
              <Box
                align="stretch"
                alignContent="center"
                alignSelf="center"
                margin={{horizontal: 'medium', vertical: 'large'}}
              >
                  <Header />
                  <Routes />
                  <Footer />
              </Box>
            </AuthProvider>
          </TranslationProvider>
        </Router>
      </QueryClientProvider>
    </ShinyConfig>
  )
}

export default App
